module.exports = __webpack_public_path__ + "static/12-365bd5894ab1e282e3145dc0658b9fc9.jpg";